import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { useState as j, useEffect as F } from "react";
import { f as n } from "./index-LyFokDcn.mjs";
import { c as l } from "./index-DkZ16bcJ.mjs";
import { I as h } from "./icon-v2-DGtVEk7e.mjs";
import { I as y } from "./icon-CvGUqXUP.mjs";
import { m as w } from "./tss-DN0acMKN.mjs";
import { f as I, a as B } from "./text-B5Opw2za.mjs";
import { M as b, d as C } from "./constants-CnFYFetN.mjs";
import { I as k } from "./icon-button-BxDvkq_l.mjs";
import { F as v } from "./floating-icon-button-CHJsoxe2.mjs";
import { I as M } from "./X12x12-BDdS6yjO.mjs";
import { L as S } from "./link-0A1muLDU.mjs";
import { T as N } from "./text-button-yPCa43NP.mjs";
const R = w()(({ palette: o }) => ({
  root: {
    display: "flex",
    fill: o.common.white
  }
}));
function T({ classes: o = {}, className: e, icon: t }) {
  const { classes: s } = R();
  return /* @__PURE__ */ r.jsx("div", { className: l(s.root, e, o.root), children: n.ifFeature(
    "encore",
    typeof t == "string" ? /* @__PURE__ */ r.jsx(h, { name: t, size: 20 }) : null,
    typeof t == "string" ? /* @__PURE__ */ r.jsx(y, { "aria-hidden": !0, name: t }) : t
  ) });
}
const A = w()(({ constructs: o, palette: e, typography: t, mode: s }, { hasClose: c, type: i }) => {
  const u = (f) => {
    switch (f) {
      case "info":
        return n.ifFeature("encore", o.surface.info.strong, e.info.main);
      case "trial":
        return n.ifFeature("encore", o.surface.neutral.xStrong, e.grey[1e3]);
      case "warning":
        return n.ifFeature("encore", o.surface.warning.strong, e.warning.main);
      case "error":
        return n.ifFeature("encore", o.surface.error.strong, e.error.main);
      default:
        return n.ifFeature("encore", o.surface.info.strong, e.info.main);
    }
  };
  return {
    closeIcon: n.ifFeature(
      "encore",
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&>.MuiButtonBase-root": {
          boxShadow: "none"
        }
      },
      {}
    ),
    content: {
      flexGrow: 1
    },
    icon: {
      marginRight: n.ifFeature("encore", 12, 11)
    },
    root: {
      alignItems: "center",
      backgroundColor: u(i),
      color: e.common.white,
      display: "flex",
      fill: e.common.white,
      fontSize: I("large"),
      fontWeight: n.ifFeature("encore", t.fontWeightMedium, t.fontWeightRegular),
      justifyContent: "space-between",
      lineHeight: B("large"),
      minHeight: n.ifFeature("encore", 32, 44),
      outline: s === b.Dye ? `2px solid ${C.main}` : void 0,
      paddingBottom: n.ifFeature("encore", 8),
      paddingTop: n.ifFeature("encore", 8),
      paddingLeft: n.ifFeature("encore", 24, 32),
      paddingRight: n.ifFeature("encore", 24, c ? 20 : 32)
    },
    // These three classes are used for sliding the banner closed
    container: {
      display: "grid",
      gridTemplateRows: "1fr",
      transition: "grid-template-rows 400ms"
    },
    innerContainer: {
      overflow: "hidden"
    },
    closing: {
      gridTemplateRows: "0fr"
    }
  };
});
function K({
  children: o,
  classes: e = {},
  className: t,
  icon: s,
  onClose: c,
  open: i = !0,
  role: u,
  type: f = "info"
}) {
  const [m, g] = j(!i), p = {
    hasClose: !!c,
    type: f
  }, { classes: a } = A(p);
  let x = "status";
  return f === "warning" && (x = "alert"), F(() => {
    let d;
    return !i && !m ? d = window.setTimeout(() => {
      g(!0);
    }, 400) : i && g(!1), () => {
      d && window.clearTimeout(d);
    };
  }, [m, i]), m ? /* @__PURE__ */ r.jsx(r.Fragment, {}) : /* @__PURE__ */ r.jsx("div", { className: l(a.container, { [a.closing]: !i && !m }), "data-fabric-component": "Banner", children: /* @__PURE__ */ r.jsx("div", { className: a.innerContainer, children: /* @__PURE__ */ r.jsxs("div", { className: l(a.root, t, e.root), role: u || x, children: [
    s && /* @__PURE__ */ r.jsx(T, { className: l(a.icon, e.icon), icon: s }),
    o && /* @__PURE__ */ r.jsx("div", { className: l(a.content, e.content), children: o }),
    c && /* @__PURE__ */ r.jsx("div", { className: l(a.closeIcon, e.closeIcon), children: n.ifFeature(
      "encore",
      /* @__PURE__ */ r.jsx(
        k,
        {
          "aria-label": window.jQuery ? $.__("Close Alert Message") : "Close Alert Message",
          color: "secondary",
          dark: !0,
          icon: "xmark-solid",
          onClick: c,
          size: "small"
        }
      ),
      /* @__PURE__ */ r.jsx(
        v,
        {
          "aria-label": window.jQuery ? $.__("Close Alert Message") : "Close Alert Message",
          clickAction: c,
          dark: !0,
          hasBounding: !1,
          icon: /* @__PURE__ */ r.jsx(M, {})
        }
      )
    ) })
  ] }) }) });
}
function U({ children: o, href: e, onClick: t }) {
  return e ? /* @__PURE__ */ r.jsx(S, { color: "inverted", href: e, onClick: t, children: o }) : /* @__PURE__ */ r.jsx(N, { dark: !0, inline: !0, onClick: t, children: o });
}
export {
  K as B,
  T as a,
  U as b
};
//# sourceMappingURL=banner-link-OSRGOGvb.mjs.map
